<template>
  <v-icon @click="handleClick" v-if="!copied" class="copy-icon">mdi-content-copy</v-icon>
  <v-icon v-else>mdi-check</v-icon>
</template>
<script>
export default {
  name: 'CopyIcon',
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    handleClick() {
      this.copied = true;
      this.$emit('click');
      setTimeout(() => {
        this.copied = false;
      }, 1500);
    },
  },
};
</script>
<style scoped lang="scss">
.copy-icon {
  &:hover {
    cursor: pointer;
  }
}

</style>
